var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );
dependencies["macros/product-video.j2"] = require( "macros/product-video.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/carousel-slides-lazy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-image.j2", false, "product/templates/carousel-slider/carousel-slides-lazy.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productImage")) {
var t_4 = t_1.productImage;
} else {
cb(new Error("cannot import 'productImage'")); return;
}
context.setVariable("productImage", t_4);
output += "\n";
env.getTemplate("macros/product-video.j2", false, "product/templates/carousel-slider/carousel-slides-lazy.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("productVideo")) {
var t_8 = t_5.productVideo;
} else {
cb(new Error("cannot import 'productVideo'")); return;
}
context.setVariable("productVideo", t_8);
output += "\n";
env.getTemplate("macros/urls.j2", false, "product/templates/carousel-slider/carousel-slides-lazy.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("productUrl")) {
var t_12 = t_9.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_12);
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_small");
frame.set("_placeholderImage", t_13, true);
if(frame.topLevel) {
context.setVariable("_placeholderImage", t_13);
}
;
}
else {
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_large");
frame.set("_placeholderImage", t_14, true);
if(frame.topLevel) {
context.setVariable("_placeholderImage", t_14);
}
;
}
output += "<div class=\"o-carousel__inner js-carousel-zoom__inner";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "shadowZoomClass"), env.opts.autoescape);
output += "\">\n\n    ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceHashToIndex")),"code")),runtime.contextOrFrameLookup(context, frame, "colorCode"));
frame.set("sliceIndex", t_15, true);
if(frame.topLevel) {
context.setVariable("sliceIndex", t_15);
}
if(frame.topLevel) {
context.addExport("sliceIndex", t_15);
}
output += "\n    ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceItems")),runtime.contextOrFrameLookup(context, frame, "sliceIndex"));
frame.set("sliceItem", t_16, true);
if(frame.topLevel) {
context.setVariable("sliceItem", t_16);
}
if(frame.topLevel) {
context.addExport("sliceItem", t_16);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "sliceItem")) {
output += "\n\n        ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceItem")),"carouselCodes")) > 0) {
output += "\n\n            ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceItem")),"carouselCodes");
if(t_19) {var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("carouselCode", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n\n                ";
var t_21;
t_21 = (lineno = 43, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pdp_carousel_slide_alt"])) + "" + " " + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") + "" + ": " + "" + runtime.contextOrFrameLookup(context, frame, "altText");
frame.set("slideAltText", t_21, true);
if(frame.topLevel) {
context.setVariable("slideAltText", t_21);
}
if(frame.topLevel) {
context.addExport("slideAltText", t_21);
}
output += "\n\n                <div class=\"o-carousel__slide js-carousel-zoom__slide ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") > 0) {
output += "o-carousel--hidden";
;
}
output += "\">\n                    <div class=\"o-carousel__flex-wrapper\">\n\n                        ";
if(t_20 == "vid") {
output += "\n                                ";
output += runtime.suppressValue((lineno = 50, colno = 48, runtime.callWrap(t_8, "productVideo", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.contextOrFrameLookup(context, frame, "baseVideoUrl"),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "colorCode"),t_20,runtime.makeKeywordArgs({"videoHeight": runtime.contextOrFrameLookup(context, frame, "videoHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"class": "c-product-image c-product-video__hero js-product-video js-video","type": "mp4","showControls": runtime.contextOrFrameLookup(context, frame, "showControls")})])), env.opts.autoescape);
output += "\n                        ";
;
}
else {
output += "\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "<a href=\"";
output += runtime.suppressValue((lineno = 65, colno = 68, runtime.callWrap(t_12, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"url"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\">";
;
}
output += "\n\n                            ";
output += runtime.suppressValue((lineno = 68, colno = 44, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "colorCode"),t_20,runtime.makeKeywordArgs({"imageHeight": runtime.contextOrFrameLookup(context, frame, "imageHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "c-product-image","disableZoom": env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "disableZoom"),runtime.contextOrFrameLookup(context, frame, "False")),"lazyImage": true,"lazyImageWidth": 400,"lazyImageHeight": 400,"lazy": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "</a>";
;
}
output += "\n\n                        ";
;
}
output += "\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "disableZoom")) {
output += "\n                            <div class=\"c-zoom-overlay js-zoom-overlay c-zoom-overlay--hidden\">\n                                ";
output += runtime.suppressValue((lineno = 92, colno = 48, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "colorCode"),t_20,runtime.makeKeywordArgs({"imageHeight": runtime.contextOrFrameLookup(context, frame, "imageHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "c-zoom-overlay__img js-zoom-overlay__img","lazyImage": true,"lazyImageWidth": 400,"lazyImageHeight": 400,"lazy": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n                            </div>\n                        ";
;
}
output += "\n\n                    </div>\n                </div>\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        ";
;
}
else {
output += "\n            <div class=\"o-carousel__slide js-carousel-zoom__slide\">\n                ";
output += runtime.suppressValue((lineno = 119, colno = 32, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.contextOrFrameLookup(context, frame, "imageStyle"),runtime.contextOrFrameLookup(context, frame, "colorCode"),runtime.contextOrFrameLookup(context, frame, "carouselCode"),runtime.makeKeywordArgs({"imageHeight": runtime.contextOrFrameLookup(context, frame, "imageHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "c-product-image","disableZoom": runtime.contextOrFrameLookup(context, frame, "True"),"defaultImage": runtime.contextOrFrameLookup(context, frame, "_placeholderImage"),"lazyImage": true,"lazyImageWidth": 400,"lazyImageHeight": 400,"lazy": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
output += "\n\n    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"defaultImage")) {
output += "\n\n        <div class=\"o-carousel__slide js-carousel-zoom__slide\">\n            <div class=\"o-carousel__flex-wrapper\">\n\n                ";
output += runtime.suppressValue((lineno = 146, colno = 32, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.makeKeywordArgs({"imageHeight": runtime.contextOrFrameLookup(context, frame, "imageHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "c-product-image","disableZoom": env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "disableZoom"),runtime.contextOrFrameLookup(context, frame, "False")),"defaultImage": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"defaultImage"),"lazyImage": true,"lazyImageWidth": 400,"lazyImageHeight": 400,"lazy": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n\n                ";
if(!runtime.contextOrFrameLookup(context, frame, "disableZoom")) {
output += "\n                    <div class=\"c-zoom-overlay js-zoom-overlay c-zoom-overlay--hidden\">\n                        ";
output += runtime.suppressValue((lineno = 165, colno = 40, runtime.callWrap(t_4, "productImage", context, [runtime.contextOrFrameLookup(context, frame, "baseImageUrl"),runtime.makeKeywordArgs({"imageHeight": runtime.contextOrFrameLookup(context, frame, "imageHeight"),"preset": runtime.contextOrFrameLookup(context, frame, "preset"),"altText": runtime.contextOrFrameLookup(context, frame, "slideAltText"),"class": "c-zoom-overlay__img js-zoom-overlay__img","defaultImage": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"defaultImage"),"lazyImage": true,"lazyImageWidth": 400,"lazyImageHeight": 400,"lazy": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n                    </div>\n                ";
;
}
output += "\n\n            </div>\n        </div>\n\n    ";
;
}
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/carousel-slides-lazy.j2"] , dependencies)